export const WORKFLOW_PENDING_FILTER_CHANGED =
  "WORKFLOW_PENDING_FILTER_CHANGED";
